export const PER_MONTH = '/Monat';
export const PER_KWH = '/kWh';
export const PAGE_SIZE = [10, 20, 25];
export const MIN_PAGE_SIZE = PAGE_SIZE[0];
export const BillingDataForOrigin = {
  CONTRACT_PAGE: 'CONTRACT_PAGE',
  BILLS_PAGE: 'BILLS_PAGE',
};